import styles from "@/styles/Price.module.scss";

export default function MemberFree() {
  return (
    <span className={`${styles.price} ${styles.svod} ${styles.trial}`}>
      <span className={styles.slate}>
        <span className={styles.bold}>会員無料</span>
      </span>
    </span>
  );
}
